export const cellWalls = {
	TOP: 			0b0001,
	RIGHT:		0b0010,
	BOTTOM:		0b0100,
	LEFT:			0b1000,
}